import $ from 'jquery';

import { View } from 'backbone';
import { Model } from 'backbone';
import util from 'util/Util';
import _Template from 'designer/layout-toolbar-pane.ejs';
import Immutable from 'immutable';
import listService from 'ListService';
import eventBus from 'EventBus';
import pageSyncService from 'PageSyncService';
import constants from 'Constants';
import factoryService from 'FactoryService';
import dragDropService from 'DragDropService';
import restService from 'RestService';
import geometryService from 'GeometryService';
import AddAssetView from 'common-views/AddAssetView';
import CommonGroupConfigView from 'common-views/CommonGroupConfigView';
import groupAllTemplate from 'toolbox/toolbox-group.ejs';
import groupButtonTemplate from 'toolbox/toolbox-group.ejs';
import groupLayoutTemplate from 'toolbox/toolbox-group.ejs';
import groupInputemplate from 'toolbox/toolbox-group.ejs';
import groupAssetemplate from 'toolbox/toolbox-group-assets.ejs';
import groupContainersTemplate from 'toolbox/toolbox-group.ejs';
import groupCommonTemplate from 'toolbox/toolbox-group-common.ejs';
import toolboxDesignerTemplate from 'toolbox/toolbox-groups.ejs';
import toolboxTabsTemplate from 'toolbox/toolbox-tabs.ejs';
import assetCollection from 'AssetCollection';
import assetUI from 'AssetUI';
import formModel from 'formModel';
import zoomService from 'ZoomService';
import focusController from 'FocusController';
import groupController from 'GroupController';
import leftPanelState   from "LeftPanelStateService";


import toolboxItemMapService from 'ToolboxItemMapService';
import crudController from 'CrudController';
import ConfirmDialogView from 'common-views/ConfirmDialogView';
import undoService from 'UndoService';
import sequenceService from 'SequenceService.js';
import MobileMenuIcon  from '../components/MobileWizard/MobileMenuIcon.js';
import utilMobile from './../mobile/commons/MobileGeneralFunctions';
import groupService from '../service/GroupService';


class ToolbarPaneView extends View {
    initialize(opts) {

        this.defaultGroup = constants.DEFAULT_TOOLBOX_GROUP;
        this.options = opts || {};
        this.template = _Template;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'click #designerView,#behaviorView,#workflowView, #mobileFormsView': 'handleLinkNavigation',
            'click .layout-switch': 'handleChangeLayout',
            'click .control-tabs li a': 'changeTabs',
            'click .asset_new': 'addAsset',
            'click .asset_delete': 'deleteAsset',

            /* PF-3527 Commented as it will be used on next versions.
             'click #zoom-in': 'zoomIn',
             'click #zoom-out': 'zoomOut',
             'click #fit-to-window': 'fitToWindow',
             'click #actual-size': 'actualSize',
            */

            'click #group,#unGroup': 'groupingUngrouping',
            'click .asset': 'assetClicked',
            'click #common_config': 'commonConfig',
            'click #deleteItem': 'deleteItem',
            'click #undoAction': 'undoAction',
            'click #redoAction': 'redoAction',
            'drop #toolSearch': 'avoidDragAndDrop',
            'click #workflowmain': 'workflowmain',
            'click #behaviors': 'behaviors',
            'keyup .edit-asset-name': 'changeAssetName',
            'focusout .edit-asset-name': 'changeAssetName'
        };

        this.templateMap = Immutable.Map([
            ['all', groupAllTemplate],
            ['buttons', groupButtonTemplate],
            ['layout', groupLayoutTemplate],
            ['input', groupInputemplate],
            ['assets', groupAssetemplate],
            ['containers', groupContainersTemplate],
            ['common', groupCommonTemplate]
        ]);

        // PF-1333
        this.selectedGroupElement = this.defaultGroup;
        this.toolboxItems = toolboxItemMapService.getLayoutItemsByGroup('all');
        this.model.set('helpUrl', constants.HELP_LAYOUT_TOOLBAR_URL);
        this.model.set('helpUrl2', constants.HELP_LAYOUT_URL);

        this.listenTo(eventBus, 'assetAdded', this.showAssets);
        this.listenTo(eventBus, 'commonGroupUpdated', this.commonGroupUpdated);

        if (!util.hasEventListener(eventBus._events, 'drawToolBarOnResizeWindow')) {
            this.listenTo(eventBus, 'drawToolBarOnResizeWindow', this.setSelectedGroup);
        }
        return this;
    }

    workflowmain(ev) {
        ev.preventDefault();
        leftPanelState.save();
        Backbone.history.loadUrl('workflowmain');
    }

    behaviors(ev) {
        ev.preventDefault();
        leftPanelState.save();
        Backbone.history.loadUrl('behaviors');
    }

    handleLinkNavigation(ev){
        listService.itemSearched = 0;
        listService.linkClicked = true;
    }

    avoidDragAndDrop() {
        return false;
    }

    undoAction() {
        undoService.undo();
        eventBus.trigger('undoCacheEvent');
    }

    redoAction() {
        undoService.redo();
        eventBus.trigger('undoCacheEvent');
    }

    deleteAssetCallback(result) {
        eventBus.trigger('assetDeletedEvent', 'ASSET', result.assetId);
    }

    deleteItem() {
        //Determine if we are deleting an Asset or Control.
        if (listService.selected.size > 0) {
            // console.log('delete control');
            crudController.deleteSelected();
        } else if (listService.selectedAsset) {
            this.deleteAsset();

        } else if (listService.mainKind === constants.KIND_LAYOUT) {
            // PF-4059 If in layout, delegate to main menu Edit delete to delete, say, the current page
            $('#designerDelete').click();
        }
    }

    addAsset(ev) {
        constants.maxItemOnSlide = assetUI.calculateItemsPerSlide(this.selectedGroupElement);
        assetUI.showLabelAssetName();
        const view = new AddAssetView({ model: this.model });
        view.render();
    }

    deleteAsset() {
        if (!listService.selectedAsset) {
            return;
        }

        assetUI.deleteAsset(this);
    }

    execDeleteAsset() {
        const
            confirmText = 'Are you sure you want to delete this image?',
            confirmTitle = 'Delete Image',
            confirmSuccess = () => {
                restService.deleteAsset(listService.selectedAsset.id, this.deleteAssetCallback);

                assetCollection.remove(listService.selectedAsset.id);
                 listService.clearSelected();
                util.enableSaveOption();
                listService.setDirty(true);
                this.showAssets();

                eventBus.trigger('selectPage');
            },

            confirmView = new ConfirmDialogView({
                model: new Model({
                    text: confirmText,
                    success: confirmSuccess,
                    title: confirmTitle,
                    height: 125, with: 400
                })
            });

        confirmView.render();

    }

    assetClicked(ev) {
        console.log("asset clicked");
        if (ev.type === "click") {
            assetUI.assetClicked(ev, this);
        }
    }

    showFieldAssetName(ev) {
        assetUI.showFieldAssetName(ev);
    }


    changeAssetName(ev) {
        assetUI.changeAssetName(ev);
    }

    commonConfig(ev) {
        const view = new CommonGroupConfigView({ model: this.model });
        view.render();
    }

    filterControls(ev) {
        ev.preventDefault();
        const buttonName = ev.currentTarget.id;

        //console.log(buttonName);

        // Clear current selection
        $('.control-groupbar div').removeClass('control-group-selected');

        // remove controls from list
        $('.factory-widget').addClass('hide');
        $('#asset_new').addClass('hide');
        $('#factories .asset').remove();

        if (buttonName === "groupAll") {
            $('#control_text').removeClass('hide');
            $('#control_small_text').removeClass('hide');
            $('#control_large_heading').removeClass('hide');
            $('#control_medium_heading').removeClass('hide');
            $('#control_small_heading').removeClass('hide');
            $('#control_picture').removeClass('hide');
            $('#control_button').removeClass('hide');
            $('#control_submit_button').removeClass('hide');
            $('#control_page_button').removeClass('hide');
            $('#control_group').removeClass('hide');
            $('#control_text_input').removeClass('hide');
            $('#control_multiple_text_input').removeClass('hide');
            $('#control_numeric_input').removeClass('hide');
            $('#control_date_input').removeClass('hide');
            $('#control_time_input').removeClass('hide');
            $('#control_date_calendar').removeClass('hide');
            $('#control_checkbox_group').removeClass('hide');
            $('#control_checkbox').removeClass('hide');
            $('#control_radio_button_group').removeClass('hide');
            $('#control_radio_button').removeClass('hide');
            $('#control_drop_down').removeClass('hide');
            $('#control_list').removeClass('hide');
            $('#control_bullet_text').removeClass('hide');
            $('#control_vertical_separator').removeClass('hide');
            $('#control_horizontal_separator').removeClass('hide');
            $('#control_sound').removeClass('hide');
            $('#control_movie').removeClass('hide');
            $('#control_link').removeClass('hide');
            $('#control_progress_bar').removeClass('hide');
            $('#control_timer').removeClass('hide');
            $('#control_print_button').removeClass('hide');
            $('#control_captcha').removeClass('hide');
            $('#control_mask_text_input').removeClass('hide');
            $('#control_numeric_stepper').removeClass('hide');
            $('#control_password_input').removeClass('hide');
            $('#control_file_attachment').removeClass('hide');
            $('#control_image_input').removeClass('hide');
            $('#control_websignature').removeClass('hide');
            $('#control_vertical_slider').removeClass('hide');
            $('#control_horizontal_slider').removeClass('hide');
            $('#control_table').removeClass('hide');
            $('#control_ranking').removeClass('hide');
            $('#control_play_form_button').removeClass('hide');
            $('#control_play_report_button').removeClass('hide');
            $('#factories .scroll-pane').css('width', '4700px');

        }

        if (buttonName === "groupInput") {
            $('#control_text_input').removeClass('hide');
            $('#control_multiple_text_input').removeClass('hide');
            $('#control_numeric_input').removeClass('hide');
            $('#control_date_input').removeClass('hide');
            $('#control_time_input').removeClass('hide');
            $('#control_date_calendar').removeClass('hide');
            $('#control_checkbox_group').removeClass('hide');
            $('#control_checkbox').removeClass('hide');
            $('#control_radio_button_group').removeClass('hide');
            $('#control_radio_button').removeClass('hide');
            $('#control_drop_down').removeClass('hide');
            $('#control_captcha').removeClass('hide');
            $('#control_mask_text_input').removeClass('hide');
            $('#control_numeric_stepper').removeClass('hide');
            $('#control_password_input').removeClass('hide');
            $('#control_file_attachment').removeClass('hide');
            $('#control_image_input').removeClass('hide');
            $('#control_table').removeClass('hide');
            $('#control_ranking').removeClass('hide');
            $('#factories .scroll-content').css('width', '2000px');

        }

        if (buttonName === "groupAssets") {
            $('#asset_new').removeClass('hide');
            $('#factories .scroll-content').css('width', '100%');
            this.showAssets();
        }

        if (buttonName === "groupButtons") {
            $('#control_button').removeClass('hide');
            $('#control_submit_button').removeClass('hide');
            $('#control_page_button').removeClass('hide');
            $('#control_play_report_button').removeClass('hide');
            $('#control_play_form_button').removeClass('hide');
            $('#control_print_button').removeClass('hide');
            $('#factories .scroll-content').css('width', '100%');

        }

        if (buttonName === "groupContainers") {
            $('#control_group').removeClass('hide');
            $('#control_checkbox_group').removeClass('hide');
            $('#control_radio_button_group').removeClass('hide');
            $('#factories .scroll-content').css('width', '100%');

        }

        $('#' + buttonName).addClass('control-group-selected');

    }

    handleChangeLayout(ev) {
        ev.preventDefault();
        leftPanelState.save();
        const target = ev.currentTarget;
        const layoutType = target.getAttribute('data-layout');
        const currentForm = listService.currentForm;
        listService.linkClicked = true;

        $('#desktop-toolbar').css('display', 'block');
        $('#mobile-toolbar').css('display', 'none');

        if (layoutType === 'deviceDesktop') {
            // No Access Needed for Desktop Layout
            this.changeLayout(target, layoutType, currentForm);
        } else {

            // AccountService.verifyResponsive().then((hasResponsive) => {

            // if (hasResponsive) {
            // if (currentForm.model.has('responsive') && util.isTrue(currentForm.model.get('responsive'))) {
            //     this.changeLayout(target, layoutType, currentForm);
            // } else {

            // var confirmationModal = new mobileDesignConfirmationModal({model: new Model()});
            // confirmationModal.render().then((result) => {

            //     var informationModal = new mobileDesignInformationModal({model: new Model()});
            //     informationModal.render().then((result) => {
            //         currentForm.model.set('responsive', true);
            //         this.changeLayout(target, layoutType, currentForm);
            //         return ('OK');
            //     }).catch((error) => {
            //         var msg = error || 'Unknown Error';
            //         console.log('Mobile information modal: ', msg)
            //         return (error);
            //     });
            //     return ('OK');
            // }).catch((error) => {
            //     var msg = error || 'Unknown Error';
            //     console.log('Mobile confirmation modal: ', msg)
            //     return (error);
            // });
            // }
            //     } else {
            //         formModel.attributes.hasResponsive = false;
            //         const
            //             alertText = constants.MSG_RESPONSIVE_DENIED,
            //             alertTitle = constants.TITLE_ENABLE_RESPONSIVE,
            //             alertVIew = new AlertDialogView({model: new Model({text: alertText, title: alertTitle})});

            //         alertVIew.render();
            //     }
            // });
        }
    }

    changeLayout(target, layoutType, currentForm) {
        leftPanelState.save();
        formModel.set({
            currentDevice: layoutType
        });

        if (layoutType === 'deviceTablet' || layoutType === 'devicePhone') {
            currentForm.model.set('responsive', true);
        }

        this.cleanUpLayoutSwitches();
        this.drawLayout(layoutType);

        if (target) {
            $(target).addClass('active');
        }

        //eventBus.trigger('selectForm');
    }

    cleanUpLayoutSwitches() {
        const layoutSwitches = this.$el.find('.layout-switch');
        layoutSwitches.map((index, item) => {
            $(item).removeClass('active')
        })
    }

    drawLayout(layoutType) {
        // Getting the current width either the one by default or the one assigned by the user via properties.
        //let currentWidth=listService.currentForm.model.attributes.formWidth;
        //let currentHeight=listService.currentForm.model.attributes.formHeight;

        let currentWidth = listService.currentForm.model.get('formWidth');
        let currentHeight = listService.currentForm.model.get('formHeight');


        const mapSizes = Immutable.Map([
            ['deviceDesktop', { width: currentWidth, height: currentHeight }],
            ['deviceTablet', { width: constants.TABLET_MAX_WIDTH, height: constants.TABLET_MAX_HEIGHT }],
            ['devicePhone', { width: constants.PHONE_MAX_WIDTH, height: constants.PHONE_MAX_HEIGHT }]
        ]);
        var newSize = mapSizes.get(layoutType);
        var newHeight = newSize.height;
        var newWidth = newSize.width;


        // Saving the current layout type inside the current model of the form.
        // This is perfomed to validate the bounds of a control in the PageSyncService.


        listService.currentForm.model.set('formHeight', newHeight, { silent: true });
        listService.currentForm.model.set('formWidth', newWidth, { silent: true });

        eventBus.trigger('formWidthSet', newWidth);
        eventBus.trigger('formHeightSet', newHeight);
        var currPage = listService.currentPageId;
        listService.currentPageId = 0;
        pageSyncService.displayPage(currPage);

        $('ul.views-options a.layout-switch').removeClass('active');
        $('ul.views-options a.layout-switch[data-layout="' + layoutType + '"]').addClass('active');

        listService.currentForm.model.trigger('change');
        eventBus.trigger('gridWidthSet', 20);
        eventBus.trigger('gridHeightSet', 20);

        // select the current control
        //$('#' + listService.currentId + ' div.pf-control-core').trigger('click');
    }

    showAssets() {
        assetUI.showAssets();
        assetUI.attachRightClickMenu(this);
        this.delegateEvents();
    }

    // PF-3527 Commented as it will be used on next versions.
    /*
    zoomIn(evt) {
        evt.preventDefault();
        zoomService.handleCanvasZoom(constants.SCALE_FACTOR_ZOOM_IN);
        let canZoom = zoomService.handleAllControlsZoom(constants.SCALE_FACTOR_ZOOM_IN);
        if (canZoom) {
            zoomService.fillZoomScaleAttribute(constants.SCALE_FACTOR_ZOOM_IN);
        }

    }

    zoomOut(evt) {
        evt.preventDefault();

        let canZoom = zoomService.handleAllControlsZoom(constants.SCALE_FACTOR_ZOOM_OUT);
        if (canZoom) {
            zoomService.fillZoomScaleAttribute(constants.SCALE_FACTOR_ZOOM_OUT);
        }
        zoomService.handleCanvasZoom(constants.SCALE_FACTOR_ZOOM_OUT);
    }
    */


    groupingUngrouping() {
        groupController.toggleGroup(listService.selected);
    }

    fitToWindow(evt) {
        evt.preventDefault();
        zoomService.handleFitToWindow();
    }

    actualSize(evt) {
        evt.preventDefault();
        listService.currentForm.model.attributes.zoomScale = undefined;
        const layoutType = formModel.attributes.currentDevice;
        this.drawLayout(layoutType);
    }

    changeTabs(ev) {
        ev.preventDefault();
        const buttonName = ev.currentTarget.id;
        const tabSectionName = ev.currentTarget.name;

        this.setSelectedGroup(tabSectionName);

    }

    commonGroupUpdated() {
        this.setSelectedGroup('common');
    }

    setSelectedGroup(sectionName, execContext = this) {
        constants.maxItemOnSlide = assetUI.calculateItemsPerSlide(sectionName);
        let context = execContext;
        this.selectedGroupElement = sectionName;

        const items = toolboxItemMapService.getLayoutItemsByGroup(sectionName);

        if (sectionName === 'common' && items.length) {
            let layoutItems = toolboxItemMapService.getLayoutItemsByGroup('all');

            items.forEach(i => {
                let control = layoutItems.find(c => c.factoryKey === i.factoryKey);
                if (control) {
                    if (control.style) {
                        i.style = control.style;
                    }

                    if (control.textStyle) {
                        i.textStyle = control.textStyle;
                    }
                }
            });
        }

        context.model.set('items', items, { silent: true });

        // reset all tab panes
        $('#factories .tab-pane').empty();

        // insert template for selected group
        const gTemplate = context.templateMap.get(sectionName);

        $('#' + sectionName).html(gTemplate(this.model.toJSON()));
        if ((items.length + 1) < constants.MAX_ITEMS_PER_SECTION_TOOLBAR) {
            $(".left.carousel-control").addClass("disable_a_href");
            $(".right.carousel-control").addClass("disable_a_href");
        }

        if (sectionName === 'assets') {
            context.showAssets();
        }
        // TODO - Custom Load Common Items - TBD
    }


    createControl(ev, factoryKey, position) {

        if (dragDropService.isFeatureEnabledForControl(factoryKey)) {
            const factoryParams = factoryService.factories[factoryKey];

            let dropPos = {
                top: position.top,
                left: position.left
            };

            // The factory knows to create properties for the model

            const isGroup = constants.GROUPS_CONTROLS_KEYS.includes(factoryKey);
            this.control = !isGroup ? factoryParams.factory.createView(factoryKey, dropPos) : groupService.createNewGroup(factoryKey, dropPos);
            
            //Validation to know if original drop position is valid
            //also validates if is a valid overlapping (at least 50% of the control over the page)
            this.control.validateToStayInBounds(this.control.model, true);
            if (this.control.model.get('invalid') === false) {
                dropPos = dragDropService.modifyControlOnEdgeDrop(dropPos, {
                    width: util.extractNum(this.control.model.get('width')),
                    height: util.extractNum(this.control.model.get('height'))
                });

                this.control.model.attributes.top = dropPos.top;
                this.control.model.attributes.left = dropPos.left;

                // PF-1301: Adding digit part/control number to control name when dropping from the search box
                sequenceService.tabIndexParentId = listService.currentPageId;
                if (sequenceService.getControlNumber() < 0) {
                    sequenceService.initControlNumber();
                }
                sequenceService.addControlNumber();
                this.control.model.set('name', this.control.model.get('name') + ' ' + sequenceService.getControlNumber(), constants.MODEL_SILENT);

                listService.addObject(this.control.id, this.control);

                groupService.droppedOnGroupObject(ev, this.control, dropPos);
                
                this.control.render();

                // Check if zoom
                if (listService.currentForm.model.attributes.zoomScale) {
                    zoomService.handleSpecificControlZoom(listService.currentForm.model.attributes.zoomScale, this.control.id);
                    // Placing the real position where the control is placed when its dropped inside the canvas and it is on zoomed mode.
                    this.control.model.attributes.top = this.control.model.attributes.top / listService.currentForm.model.attributes.zoomScale;
                    this.control.model.attributes.left = this.control.model.attributes.left / listService.currentForm.model.attributes.zoomScale;
                }

                utilMobile.addedNewObjectToDesktopCanvas(this.control);
               
                // Mark the control -- only happens at creation drop. Subsequent focus change un-marks the control
                //focusController.markControl(control.id, true);
                listService.currentId = this.control.model.get('id');

                // Paint the properties
                //focusController.switchPropsViews();
                $('#' + listService.currentId + ' div.pf-control-core').trigger('click');
                $('#' + listService.currentId).trigger('focus');

                window.setTimeout(() => {
                    $(constants.ID_SEL + this.control.id).trigger(constants.EV_CLICK + focusController.namespace);
                    util.updateHelpDocumentationLink(this.control.model.get('factoryKey'));
                    eventBus.trigger(constants.EV_DELETE_TREE_FILTER);
                }, 0);
            } else {
                console.log('element out of boundaries');
            }
            
            // Note: listenForInstanceDragStart() called by pageView
            dragDropService.listenForDrop(constants.ID_SEL + this.control.id);
        }
    }

    render() {
        var self = this;
        this.$el.empty();

        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        $('ul.views-options a.layout-switch').removeClass('active');
        $('#designerView a').addClass('active');

        $('#toolbox-tabs').html(toolboxTabsTemplate);
        $('#factories').html(toolboxDesignerTemplate);

        constants.maxItemOnSlide = assetUI.calculateItemsPerSlide(this.selectedGroupElement);
        this.setSelectedGroup(this.selectedGroupElement);

        let selected = false;
        let initialEdges = {};

        if (listService.mainKind === 'R' && !listService.resizeWhenTooling) {
            listService.resizeWhenTooling = true;
            $(window).on('resize', (e) => {
                if (self.selectedGroupElement === 'assets') {
                    let maxItems = assetUI.calculateItemsPerSlide(self.selectedGroupElement);
                    if (maxItems !== constants.maxItemOnSlide) {
                        constants.maxItemOnSlide = maxItems;
                        eventBus.trigger('drawToolBarOnResizeWindow', self.selectedGroupElement, self);
                    }
                }
            });
        }

        dragDropService.initSearchToolBoxDraggable(selected, initialEdges, this.toolboxItems);

        // Required delegate events so toolbar actions can be performed.
        this.delegateEvents();

        // Mobile forms wizard.
        MobileMenuIcon.render('mobileFormsView', { activeTab: listService.activeDashboardTab });
    }
 

    remove() {
        if (this.control) {
            this.control.remove();
            dragDropService.unlistenForDrop(constants.ID_SEL + this.control.id);
        }

        $('#toolSearch').off('typeahead:selected');
        this.$el.empty();
        this.undelegateEvents();
        this.off();

        super.remove();
    }
}

export default ToolbarPaneView;
